import { render } from "./configuratorOrderPosition.vue?vue&type=template&id=47b4f9ae"
import script from "./configuratorOrderPosition.vue?vue&type=script&lang=js"
export * from "./configuratorOrderPosition.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__